module.exports = __webpack_public_path__ + "static/media/furture.e48ff98a.png";